import auth from './auth';
import form from './form';

import {createStore} from 'vuex';
 
const store = createStore({
    modules:{
        auth: auth,
        form: form,
    }
});
 
export default store;